import { Component } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { Router } from '@angular/router';
import { AccountService } from '../account.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'confirm-reset-password',
  template: `<loading-animation [color]="'#fff'"></loading-animation>`,
})
export class ActivateAccountComponent {
  constructor(
    private accountService: AccountService,
    private toasterService: ToasterService,
    private translate: TranslateService,
    private router: Router
  ) {
    this.activate();
  }

  activate() {
    this.accountService.activate().subscribe(
      () => {
        this.translate
          .get('account_activated_successfully')
          .subscribe(message => {
            this.router.navigate(['/stories']);
            this.toasterService.pop('success', undefined, message);
          });
      },
      data => {
        const error = data.error;
        if (error.detail) {
          this.toasterService.pop('error', undefined, error.detail);
        }
        this.router.navigate(['/stories']);
      }
    );
  }
}
